import { useQuery } from '@apollo/client/react';
import { QUERY_DOG_RESCUES_PAGE } from '../../graphql/dog-queries';

export default function useGetDogRescuesPage(slug) {
    const { data, loading } = useQuery(QUERY_DOG_RESCUES_PAGE, {
        variables: { slug },
    });
    return { data: data?.dogRescuePage, loading };
}
